import { Directive, input } from '@angular/core'

import { injectSetPayloadAttributeFn } from 'app/utils/set-payload-attribute.function'
import { explicitEffect } from 'app/utils/signal-utils'

// todo move into reusable type somewhere
interface CmsBlockData {
  __typename: string
  id: string | null // actually never really null
}

@Directive()
export abstract class CmsBlock<T extends CmsBlockData> {
  // todo rename it to _blockName; should not be connected to graphql
  abstract readonly __typename: string
  readonly data = input.required<T>()

  constructor() {
    const setPayloadAttributes = injectSetPayloadAttributeFn()
    explicitEffect(this.data, ({ id, __typename }: T) => void (id && setPayloadAttributes({ id, __typename })))
  }
}
